import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function useCancelNavigation(fallbackPath) {
  const navigate = useNavigate();

  return useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  }, [navigate, fallbackPath]);
}